/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rv_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Word mode reverses the order of words and normalizes runs of spaces, tabs, and newlines to a single space between words.`)
};

const es_rv_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El modo de palabras invierte el orden de las palabras y normaliza las series de espacios, tabulaciones y saltos de línea a un solo espacio entre palabras.`)
};

const de_rv_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Wörter-Modus kehrt die Reihenfolge der Wörter um und normalisiert Folgen von Leerzeichen, Tabulatoren und Zeilenumbrüchen zu einem einzigen Leerzeichen zwischen den Wörtern.`)
};

const nl_rv_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Woorden modus keert de woordvolgorde om en normaliseert reeksen spaties, tabs en regelafbrekingen tot één spatie tussen woorden.`)
};

const fr_rv_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le mode Mots inverse l'ordre des mots et normalise les séries d'espaces, de tabulations et de sauts de ligne en un seul espace entre les mots.`)
};

const it_rv_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La modalità Parole inverte l'ordine delle parole e normalizza le serie di spazi, tabulazioni e interruzioni di riga in uno spazio singolo tra le parole.`)
};

const pt_br2_rv_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O modo Palavras inverte a ordem das palavras e normaliza sequências de espaços, tabulações e quebras de linha para um único espaço entre palavras.`)
};

const pt_rv_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O modo Palavras inverte a ordem das palavras e normaliza sequências de espaços, tabulações e quebras de linha para um único espaço entre palavras.`)
};

const ja_rv_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単語モードは単語の順序を逆にし、スペース、タブ、改行を単語間の1つのスペースに正規化します。`)
};

const zh_rv_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`单词模式会反转单词顺序，并将连续的空格、制表符和换行符统一规范为单词之间的一个空格。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rv_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rv_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rv_faq2_a", locale)
	if (locale === "en") return en_rv_faq2_a(inputs)
	if (locale === "es") return es_rv_faq2_a(inputs)
	if (locale === "de") return de_rv_faq2_a(inputs)
	if (locale === "nl") return nl_rv_faq2_a(inputs)
	if (locale === "fr") return fr_rv_faq2_a(inputs)
	if (locale === "it") return it_rv_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_rv_faq2_a(inputs)
	if (locale === "pt") return pt_rv_faq2_a(inputs)
	if (locale === "ja") return ja_rv_faq2_a(inputs)
	return zh_rv_faq2_a(inputs)
};